"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVELOPER_ONLY_IDENTITY_TYPES = exports.ACUMEN_IDENTITY_TYPES = exports.IdentityType = void 0;
var IdentityType;
(function (IdentityType) {
    IdentityType["ACUMEN"] = "Acumen";
    IdentityType["JIRA"] = "Jira";
    IdentityType["GITHUB_COLLABORATOR"] = "GitHubCollaborator";
    IdentityType["GITHUB_CONTRIBUTOR"] = "GitHubContributor";
    IdentityType["SLACK"] = "Slack";
    IdentityType["GO_RETRO"] = "GoRetro";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
exports.ACUMEN_IDENTITY_TYPES = Object.values(IdentityType)
    .filter(identity => identity !== IdentityType.GO_RETRO);
exports.DEVELOPER_ONLY_IDENTITY_TYPES = [
    IdentityType.GITHUB_COLLABORATOR,
    IdentityType.GITHUB_CONTRIBUTOR,
];
//# sourceMappingURL=identity.js.map